export default {
  formFields: null,
  comments: [],
  current: null
}
